import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'sponsor-component',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
    ],
    templateUrl: 'sponsor.component.html',
    styleUrl: './sponsor.component.css'
})
export class SponsorComponent implements OnInit,OnDestroy{
    private restartDelay = 10*60000
    private videoEndListener: any
  
    constructor() {}
  
    ngOnInit() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        const videoElement = document.querySelector('#bannerAlkorex') as HTMLVideoElement;

        videoElement.addEventListener('ended', this.handleVideoEnd.bind(this))
    }
  
    ngOnDestroy() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        const videoElement = document.querySelector('#bannerAlkorex') as HTMLVideoElement;

        videoElement.removeEventListener('ended', this.handleVideoEnd.bind(this))
    }
  
    handleVideoEnd() {
        
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }

        setTimeout(() => {
            const videoElement = document.querySelector('#bannerAlkorex') as HTMLVideoElement;

            videoElement.currentTime = 0
            videoElement.play()
        }, this.restartDelay)
    }
}